<template>
  <header class="topbar">
    <h2 class="page-title">{{ title.replace('-', ' ') | ucwords }}</h2>
    <dropdown-wrapper position="top-end">        
      <avatar
        class="pointer"
        name="Warren Hansen"
        slot="trigger"
        slot-scope="{ isActive }"
        :class="isActive ? 'chevron-down' : 'chevron-up'">
      </avatar>

      <dropdown-item custom class="pointer has-text-weight-bold">
        <span class="is-flex justify-between" @click="signOut">
          <span>Sign Out</span>
          <icon icon="sign-out-alt"/>
        </span>
      </dropdown-item>     
    </dropdown-wrapper>
  </header>
</template>
<script>
export default {

  data: () => ({
    title: ''
  }),
  
  methods: {
    signOut() {
      this.$store.commit('auth/deleteToken')
      this.$router.push({ name: 'login'})
    },
    setTitle() {
      this.title = this.$route.name
    }
  },

  watch: {
    '$route': 'setTitle'
  }

}
</script>
